import { render, staticRenderFns } from "./user-input.vue?vue&type=template&id=680d07b7&scoped=true&"
import script from "./user-input.vue?vue&type=script&lang=js&"
export * from "./user-input.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680d07b7",
  null
  
)

export default component.exports